import { useState } from "react";
import RadioInput from "../ui/RadioInput";
import Channels from "./Channels";
import { ChannelType } from "../../hooks/use-talkie-walkie";
import { useAudioEffects } from "../../../../hooks/use-audio-effects";
import walkieConnectSound from "../../../../assets/audio/station-found.wav";

interface Props {
  className?: string;
}

const RadioConnect = ({ className = "" }: Props) => {
  const [selectedChannel, setSelectedChannel] = useState<ChannelType>();
  const { playEffect } = useAudioEffects();

  return (
    <div className={`rounded-b-xl ${className}`}>
      <RadioInput
        className="my-2"
        value={selectedChannel?.mhz?.toString()}
        onConnect={() => {
          playEffect(walkieConnectSound);
        }}
      />
      <Channels
        title="Favorite Channels"
        onChannelSelect={setSelectedChannel}
      />
    </div>
  );
};

export default RadioConnect;
